export * from './Component'
export type { CommonPopoverProps } from './typing'
